import React from 'react';
import { Toaster } from 'sonner';
import { AppToastIcon } from './AppToastIcon';

export function AppToaster() {
    return (
        <Toaster
            position="top-center"
            expand={false}
            richColors={false}
            closeButton
            duration={5000}
            visibleToasts={4}
            gap={14}
            offset={20}
            icons={{
                success: <AppToastIcon type="success" />,
                error: <AppToastIcon type="error" />,
                warning: <AppToastIcon type="warning" />,
                info: <AppToastIcon type="info" />,
            }}
            toastOptions={{
                unstyled: true,
                classNames: {
                    toast: 'app-toast',
                    title: 'app-toast__message',
                    closeButton: 'app-toast__close',
                },
            }}
        />
    );
}

export default AppToaster;
